import api from './api';
import {
  ChartOfAccount,
  CreateChartOfAccountDto,
  UpdateChartOfAccountDto,
  ChartOfAccountFilters,
} from '../types/chartOfAccount';

const CHART_OF_ACCOUNTS_ENDPOINT = '/ChartOfAccounts';

export const chartOfAccountService = {
  /**
   * Get all chart of accounts with optional filters
   */
  getAll: async (filters?: ChartOfAccountFilters): Promise<ChartOfAccount[]> => {
    const params = new URLSearchParams();
    
    if (filters?.includeInactive !== undefined) {
      params.append('includeInactive', filters.includeInactive.toString());
    }
    
    if (filters?.accountType) {
      params.append('accountType', filters.accountType);
    }
    
    if (filters?.onlyFinalAccounts !== undefined) {
      params.append('onlyFinalAccounts', filters.onlyFinalAccounts.toString());
    }

    const queryString = params.toString();
    const url = queryString 
      ? `${CHART_OF_ACCOUNTS_ENDPOINT}?${queryString}` 
      : CHART_OF_ACCOUNTS_ENDPOINT;

    const response = await api.get<any>(url);
    
    // Extract data - handle both direct array and wrapped response
    const data = response.data?.data || response.data;
    return Array.isArray(data) ? data : [];
  },

  /**
   * Get chart of account by ID
   */
  getById: async (id: number): Promise<ChartOfAccount> => {
    const response = await api.get<any>(`${CHART_OF_ACCOUNTS_ENDPOINT}/${id}`);
    return response.data?.data || response.data;
  },

  /**
   * Get chart of accounts as tree structure
   */
  getTree: async (): Promise<ChartOfAccount[]> => {
    const response = await api.get<any>(`${CHART_OF_ACCOUNTS_ENDPOINT}/tree`);
    const data = response.data?.data || response.data;
    return Array.isArray(data) ? data : [];
  },

  /**
   * Create new chart of account
   */
  create: async (data: CreateChartOfAccountDto): Promise<ChartOfAccount> => {
    const response = await api.post<any>(CHART_OF_ACCOUNTS_ENDPOINT, data);
    return response.data?.data || response.data;
  },

  /**
   * Update existing chart of account
   */
  update: async (id: number, data: UpdateChartOfAccountDto): Promise<ChartOfAccount> => {
    const response = await api.put<any>(
      `${CHART_OF_ACCOUNTS_ENDPOINT}/${id}`,
      data
    );
    return response.data?.data || response.data;
  },

  /**
   * Delete chart of account (soft delete - deactivate)
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${CHART_OF_ACCOUNTS_ENDPOINT}/${id}`);
  },
};